import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HomePage } from "./view/merchant/hompage/homepage";
import ErrorPage from "./view/merchant/error/ErrorPage";
import { Registration } from "./view/merchant/registration/component/registration";
import { MerchantCommission } from "./view/merchant/merchantComission/merchantCommission";
import { AuditLogs } from "./view/merchant/audit/audit";
import Aos from "aos";
import "aos/dist/aos.css";
import { lazy, Suspense, useEffect } from "react";
import { ProtectedRoutes } from "./view/merchant/protected-routes";
import { XpressLoader } from "./shared/component/loader";
import UserSettings from "./view/merchant/user-settings";
import { ConfigProvider } from "antd"
import { getThemeConfig } from "./themeConfig";

const GetStarted = lazy(() => import("./view/merchant/getstarted/GetStarted"));
// const Profile = lazy(() => import("./view/merchant/profile/profile"));
const ManageUsers = lazy(() => import("./view/merchant/manage users/manageUsers"));
const Billers = lazy(() => import("./view/merchant/billers/Billers"));
const Reports = lazy(() => import("./view/merchant/reports/index"));
const Wallet = lazy(() => import("./view/merchant/wallet/Wallet"));
const Settings = lazy(() => import("./view/merchant/settings/Settings"));
const Transactions = lazy(() => import("./view/merchant/transaction"));
const Products = lazy(() => import("./view/merchant/products/products"));
const Roles = lazy(() => import("./view/merchant/roles/roles"));
const BulkAirtime = lazy(() => import("./view/merchant/bulk-airtime/index"))

export const App = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const isLoggedIn = () => {
    if (!sessionStorage.getItem("*****")) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <ConfigProvider theme={getThemeConfig()}>
    <Suspense fallback={<XpressLoader />}>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <GetStarted />
              </ProtectedRoutes>
            }
          ></Route>
          {/* <Route
            path="/profile"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <Profile />
              </ProtectedRoutes>
            }
          ></Route> */}
          <Route
            path="/manage-roles"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <Roles />
              </ProtectedRoutes>
            }
          ></Route>
          <Route
            path="/manage-users"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <ManageUsers />
              </ProtectedRoutes>
            }
          ></Route>
          
          {/* <Route path="/category" element={<Category />}></Route> */}
          <Route
            path="/billers"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <Billers />
              </ProtectedRoutes>
            }
          ></Route>
          <Route
            path="/bills-payment"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <Transactions />
              </ProtectedRoutes>
            }
          ></Route>
          <Route
            path="/bulk-airtime"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <BulkAirtime />
              </ProtectedRoutes>
            }
          ></Route>
          <Route
            path="/products"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <Products />
              </ProtectedRoutes>
            }
          ></Route>
          <Route
            path="/commission"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <MerchantCommission />
              </ProtectedRoutes>
            }
          ></Route>
          <Route
            path="/reports"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <Reports />
              </ProtectedRoutes>
            }
          ></Route>
          <Route
            path="/wallet"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <Wallet />
              </ProtectedRoutes>
            }
          ></Route>
          <Route
            path="/merchant-settings"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <Settings />
              </ProtectedRoutes>
            }
          ></Route>
          
          <Route
            path="/user-settings"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <UserSettings />
              </ProtectedRoutes>
            }
          ></Route>
          <Route
            path="/audit-logs"
            element={
              <ProtectedRoutes isLoggedIn={isLoggedIn()}>
                <AuditLogs />
              </ProtectedRoutes>
            }
          ></Route>
          <Route
            path="/merchant-registration"
            element={<Registration />}
          ></Route>
          <Route path="*" element={<ErrorPage />}></Route>
        </Routes>
      </Router>
    </Suspense>
    </ConfigProvider>
  );
};
